import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { SITE } from "@/lib/siteData";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 pt-16 pb-8 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <img src={SITE.logo.light} alt="Sphère Auto" className="h-20 w-auto mb-4 bg-white rounded-lg p-2" />
            <p className="text-sm text-slate-400 leading-relaxed">
              Votre centre auto de proximité à Loos-en-Gohelle. Mécanique, dépannage, carte grise, achat/vente.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Carte Grise</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Mécanique</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Dépannage</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Achat / Vente / Reprise</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Pièces Auto</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Diagnostic Offert</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-2"><MapPin className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" /><span>{SITE.address.street}<br/>{SITE.address.zip} {SITE.address.city}</span></li>
              <li><a href={SITE.phoneTel} className="flex gap-2 hover:text-blue-400 transition-colors" data-testid="footer-phone"><Phone className="w-4 h-4 text-blue-400 flex-shrink-0" />{SITE.phoneDisplay}</a></li>
              <li><a href={`mailto:${SITE.email}`} className="flex gap-2 hover:text-blue-400 transition-colors break-all" data-testid="footer-email"><Mail className="w-4 h-4 text-blue-400 flex-shrink-0" />{SITE.email}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">Horaires</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start gap-2"><Clock className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" /><div><div className="text-white font-semibold">{SITE.hours.days}</div><div>{SITE.hours.time}</div></div></li>
              <li className="text-slate-500 text-xs pl-6">{SITE.hours.closed}</li>
              <li className="mt-3 inline-flex items-center gap-2 text-xs font-bold text-red-400 pl-6">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse" />
                {SITE.hours.emergency}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} Sphère Auto. Tous droits réservés.
          </div>
          <div className="text-xs text-slate-500 text-center sm:text-right" data-testid="footer-legal">
            SIRET : 999 984 446 — RCS Arras<br />
            Garage automobile à Loos-en-Gohelle (62750)
          </div>
        </div>
      </div>
    </footer>
  );
}
